import React from 'react';
import './Header.css';

const Header = () => {
  

  return (
    <div>
      <header className="header">
        <a href="#home" className="logo"><span>Lakshan Hewagama</span></a>
        <nav className='navbar'>
          <a href="#home" className="active">Home</a>
          <a href="#about">About</a>
          <a href="#skills">Skills</a>
          <a href="#portfolio">Portfolio</a>
          <a href="#contact">Contact</a>
        </nav>
      </header>
      <div className='nav-alert'>
          <h3>Scroll Down to Explore about Me!</h3>
        </div>
    </div>
  );
};

export default Header;
